import { muiStyles } from 'utils/design';

export const useStyles = muiStyles(() => ({
  icon: {
    fontSize: '0.9rem',
  },
}));
